import { ConfigItem } from 'Core/interfaces'

import { IsUsedInItemEntity } from '.'

export enum ContainerTypeSearchFields {
	searchById = 'searchById',
	searchByName = 'searchByName',
	searchByCode = 'searchByCode'
}

export declare namespace ContainerType {
	interface Basic extends CodeEntity {}
	interface Detailed extends CodeEntity {
		productStates: IsUsedInItemEntity[]
	}

	namespace Form {
		interface Generic {
			code: string
			name: string
			productStateIds: LabelValueDisabled<number>[]
		}
	}
	namespace Request {
		interface Generic {
			code: string
			name: string
			productStateIds: number[]
		}
	}
	namespace Search {
		interface Config {
			[ContainerTypeSearchFields.searchById]: ConfigItem<ContainerTypeSearchFields>
			[ContainerTypeSearchFields.searchByName]: ConfigItem<ContainerTypeSearchFields>
			[ContainerTypeSearchFields.searchByCode]: ConfigItem<ContainerTypeSearchFields>
		}
		interface Result {
			[ContainerTypeSearchFields.searchById]: Entity[]
			[ContainerTypeSearchFields.searchByName]: Entity[]
			[ContainerTypeSearchFields.searchByCode]: Entity[]
		}
	}
}
